import { Card, CardContent, CardHeader, CircularProgress } from '@mui/material';

import { OnboardingNoteMessage } from './useDashboard';

const OnboardingNotesCard = ({
	data,
	isFetching,
	isTVMode,
}: {
	data?: OnboardingNoteMessage[];
	isFetching?: boolean;
	isTVMode?: boolean;
}) => {
	return (
		<Card style={{}}>
			<CardHeader
				style={{ paddingBottom: 0 }}
				title="שיתופים מהאונבורדינג"
				action={
					<div style={{ width: 64 }}>{isFetching ? <CircularProgress size={16} /> : null}</div>
				}
			/>
			<CardContent style={{ height: 300, overflowY: 'scroll' }}>
				<table
					className="border-separate border-spacing-y-1 border-spacing-x-0"
					style={{ tableLayout: 'fixed', fontSize: isTVMode ? 20 : 16 }}
				>
					<thead className="text-start bg-gray-200">
						<th className="text-start">שיתוף</th>
						<th className="text-center">חברה</th>
					</thead>
					{data?.map(({ text, company }) => (
						<tr className="">
							<td className="w-full text-start">{text}</td>
							<td className={`text-center text-${isTVMode ? 'lg' : 'sm'}`}>{company}</td>
						</tr>
					))}
				</table>
			</CardContent>
		</Card>
	);
};

export default OnboardingNotesCard;
